import aliceDoctorIpadLandscapeImg from "../../../assets/img/alice-ipad-doctor-landscape.png"
import aliceDoctorIpadLandscapeImgWebp from "../../../assets/img/alice-ipad-doctor-landscape.webp"

const AllStartedCake = () => (
    <section id="all-started-cake">
        <div className="container-fluid">
            <div className="row justify-content-center align-items-center py-4">
                <div className="col-xxl-8 col-lg-10 col-11 px-xxl-4 px-3 ">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-md-6 col-12 mt-lg-0 mt-3 pe-md-0 text-md-start text-center">
                            <h3 className="fw-bold mb-5">
                                And it all started…<br />
                                With a slice of birthday cake.
                            </h3>
                            <p>Alice wasn’t a stranger.</p>
                            <p>We used to work together at a packaging plant before the layoffs. Always sharp, always smiling, even when things were tough.</p>
                            <p className="my-4">The kind of person you remember.</p>
                            <p>
                                We hadn’t seen each other in weeks, and I almost didn’t recognise her at first.<br />
                                She looked lighter, brighter… not just physically, but like someone who’d quietly dropped a heavy backpack and just kept walking.
                            </p>
                        </div>
                        <div className="col-xxl-4 col-lg-5 col-md-5 col-12 align-items-center text-center">
                            <picture>
                                <source srcSet={aliceDoctorIpadLandscapeImgWebp} type="image/webp" />
                                <img className="img-fluid gg-border-radius" src={aliceDoctorIpadLandscapeImg} loading="lazy" />
                            </picture>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default AllStartedCake;